

<template>
  <div class="login">
    <span style="font-size: 48px">医废智能管理系统</span>
    <div style="margin-top: 30px;" >
      账号：
      <el-input v-model="acc" placeholder="请输入账号" class="input" clearable>aa</el-input>
    </div>
    <div style="margin-top: 30px;">
      密码：
      <el-input v-model="pwd" placeholder="请输入密码"  class="input" show-password clearable>bb</el-input>
    </div>
    <div>
      <p></p>
      <el-switch
        v-model="rpwd"
        @change="onRpwdChange"
        active-text="记住密码"
        inactive-text="请勿在不安全环境使用">
      </el-switch>
    </div>
    <el-button style="margin-top: 30px; width:200px" type="success" :loading="isLoging" @click="onSubmit">登陆</el-button>
  </div>
</template>

<script>
  import WS from "./ws.js"
  import Config from "./config.js"
  export default {
    name: "login",
    data(){
      return{
        acc:"",
        pwd:"",
        isLoging:false,

        rpwd:true,
        // rememberPwd:true,
      }
    },
    created(){
      if (localStorage.rpwd!==undefined){
        this.rpwd=localStorage.rpwd=="true";
      }
      if (localStorage.acc!==undefined) {
        this.acc = localStorage.acc;
      }
      if (localStorage.pwd!==undefined) {
        this.pwd=localStorage.pwd
      }
    },
    mounted() {
      // if (window.ws!=undefined&&window.ws !=null){
      //   this.$router.push("/m");
      //   return;
      // }
    },
    methods:{
      onRpwdChange(){
        if (this.rpwd===false){
          localStorage.acc="";
          localStorage.pwd="";
          localStorage.rpwd=false;
        }
      },
      onSubmit(e){
        //console.log(this.acc,this.pwd,e.target.disabled);
        if (this.acc==""){
          this.$alert('请输入账号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.pwd==""){
          this.$alert('请输入密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        this.isLoging=true;
        e.target.disabled=true;
        let $this=this;
        this.timeoutHandle=setTimeout(function(){
          $this.isLoging=false;
          e.target.disabled=false;
        },3000);

        window.ws=new WS();
        let ws=window.ws;
        ws.AddFunc("onConnectFail",function () {
          $this.$alert('连接服务器失败，请稍后重试，或联系管理员', '错误', {
            confirmButtonText: '确定'
          });
        });
        ws.AddFunc("onConnect",function(){
         // console.log("链接成功！");
          ws.Call("W2S_Login",$this.acc,$this.pwd)
        });

        if ($this.rpwd===false){
          localStorage.acc="";
          localStorage.pwd="";
          localStorage.rpwd=false;
        }

        ws.AddFunc("S2W_LoginRes",function (code,name,role,power,companyID,companyName,hospitalCode) {
          clearTimeout($this.timeoutHandle)
          $this.isLoging=false;
          e.target.disabled=false;
          if (code==1) {
            //console.log("登陆成功！");
            if ($this.rpwd===true){
              localStorage.acc=$this.acc;
              localStorage.pwd=$this.pwd;
              localStorage.rpwd=$this.rpwd;
            }
            window.userName=name;
            window.userRole=role;
            window.power=power;
            window.companyID=hospitalCode;//companyID;
            window.companyName=companyName;
            $this.$router.push("/m");
          }else{
            $this.$alert('错误的用户名或密码！', '登录错误', {
              confirmButtonText: '确定'
            });
          }
        });
        ws.AddFunc("onDisConnect",function () {
         // console.log("--->",$this.$router.currentRoute);
          if ($this.$router.currentRoute.path!="/") {
            $this.$router.push("/");
          }
          console.log("链接已断开！");
        });
        ws.Open("server",Config.WSS);
      }
    }
  }
</script>


<style>
  .login{
    margin-top: 240px
  }

  .input{
    width: 400px;
  }
  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 480px;
  }
</style>




// WEBPACK FOOTER //
// src/view/login.vue